<script lang="ts" setup>
import type LxcError from "~/core/models/LxcError.class";

const props = defineProps<{
  error?: LxcError | null;
  isLoading?: boolean;
  loaderSize?: 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 14 | 16 | 20 | 24 | 28;
  px?: number;
  py?: number;
  loaderContainerClass?: string | string[];
}>();

const DEFAULT_PADDING_X = 8;
const DEFAULT_PADDING_Y = 6;

const paddingYInPx: ComputedRef<number> = computed(
  () => (props.py ?? DEFAULT_PADDING_Y) * 4,
);
const paddingTop: ComputedRef<number> = computed(() => paddingYInPx.value);
const paddingBottom: ComputedRef<number> = computed(() => paddingYInPx.value);

const lxcContainerClass = computed(() => [
  `px-${props.px ?? DEFAULT_PADDING_X}`,
  `py-${props.py ?? DEFAULT_PADDING_Y}`,
]);

const loaderWrapperClass = computed(() => {
  const loaderWrapperClass = ["mt-20", "flex", "justify-center"];
  const propClass: string[] | undefined = Array.isArray(
    props.loaderContainerClass,
  )
    ? props.loaderContainerClass
    : props.loaderContainerClass?.split(" ");

  return loaderWrapperClass.concat(propClass ?? []);
});

defineExpose({
  paddingTop,
  paddingBottom,
});
</script>

<template>
  <div :class="lxcContainerClass">
    <div v-if="isLoading" :class="loaderWrapperClass">
      <lxc-loader :size="loaderSize || 28" />
    </div>

    <!-- This DIV add a smooth transition effect of appearance of the content -->
    <div
      :class="`${isLoading ? 'opacity-0' : 'opacity-100'} flex grow flex-col transition-opacity duration-300 ease-in`"
    >
      <error-component v-if="!isLoading && error" :error="error" />

      <!-- The slot must not be displayed before loading ends because it avoids LxcSelect components to set their initial value -->
      <slot v-if="!isLoading && !error" />
    </div>
  </div>
</template>
